import React from 'react';
import { PlusOutlined, ReloadOutlined } from '@ant-design/icons';

export const getTreePanelButtons = ({
  onRefresh,
  onCreate,
}: {
  onRefresh: () => void;
  onCreate: () => void;
}) => [
  {
    key: 'refresh',
    icon: <ReloadOutlined />,
    type: 'text' as const,
    onClick: onRefresh,
    title: '刷新',
    showTextOnHover: true,
  },
  {
    key: 'create',
    icon: <PlusOutlined />,
    type: 'primary' as const,
    onClick: onCreate,
    text: '新建',
  },
];

export const getTablePanelButtons = ({ onRefresh }: { onRefresh: () => void }) => [
  {
    key: 'refresh',
    icon: <ReloadOutlined />,
    type: 'text' as const,
    onClick: onRefresh,
    title: '刷新',
    showTextOnHover: true,
  },
];
